import { createFileRoute } from "@tanstack/react-router";
import { StreamPage } from "../features/labs/stream-page";

// Hidden diagnostic (ADR 0009): no navigation entry, no palette command.
export const Route = createFileRoute("/_app/labs/stream")({ component: StreamPage });
